import Grid from '@mui/material/Grid';
import DataField from '../../atoms/dataField';
import React, {FC, useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import { CONNECTION_TYPES } from '../../../constants/_pickerValues';
import { IFormField } from '../../shared/globalTypes';


interface Props {
  selectedConnection: string,
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
  shareName: IFormField,
  winPath: IFormField,
  winUsername: IFormField,
  winPassword: IFormField,
}

const ConnectionWindowsFileshare:FC<Props> = ({selectedConnection, onChange, shareName, winPath, winUsername, winPassword }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    (selectedConnection===CONNECTION_TYPES.windowsFileshare) ? setVisible(true) : setVisible(false);
    
  }, [selectedConnection]);

  if (visible) {
    return (
      <Box sx={{ border: 1, borderColor: 'divider', padding: 3, width: '100%' }}>
        <h2>{selectedConnection}</h2>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <DataField id="1751773b-7320-4a1d-826c-7160f1091646"
              label='Sharename'
              name='shareName' 
              type='text'
              required={true}
              onChange={onChange}
              value={shareName.fieldValue}
              error={shareName.isError}
          />
          </Grid>
          <Grid item xs={7}>
            <DataField id="6e9233d9-db0c-49eb-b383-949b4c56defe"
              label='Path'
              name='winPath' 
              type='text'
              required={true}
              onChange={onChange}
              value={winPath.fieldValue}
              error={winPath.isError}
          />
          </Grid>
          <Grid item xs={3}>
            <DataField id="10c6c1a6-2076-4f78-af61-8204a8658da1"
              label='Username'
              name='winUsername' 
              type='text'
              required={true}
              onChange={onChange}
              value={winUsername.fieldValue}
              error={winUsername.isError}
          />
          </Grid>
          <Grid item xs={3}>
            <DataField id="67b6ae08-85df-45f9-80bf-698c67036108"
              label='Password'
              name='winPassword' 
              type='password'
              required={true}
              onChange={onChange}
              value={winPassword.fieldValue}
              error={winPassword.isError}
          />
          </Grid>
        </Grid>
      </Box>
    )
  } else {
    return <></>
  }
  
};

export default ConnectionWindowsFileshare;